/* src/app/components/user/profile/profile.component.scss */
.row {
  height: 60px;
  margin-bottom: 20px;
}
.title {
  font-size: 10.75px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.54);
  padding-bottom: 5px;
  -webkit-transform: perspective(100px) translateZ(0.001px);
  transform: perspective(100px) translateZ(0.001px);
}
:host-context(.dark-theme) .title {
  color: rgba(255, 255, 255, 0.6);
}
/*# sourceMappingURL=profile.component.css.map */
